import { string, object, number } from 'yup';
import { checkIsraeliPhone } from '../helpers';

export const customerAssignmentsListSearchValidation = object().shape({
  customerPhoneNumber: string()
    .test('check phone number', 'מספר הפלאפון לא תקין', (value) => {
      return value ? checkIsraeliPhone(value) : true;
    }),
  fullNameFromContractor: string().max(100, 'יש להזין עד 100 תווים בלבד'),
  siteId: number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null || originalValue === undefined ? undefined : value
    )
    .integer('נא להכניס מספר אתר תקין')
    .positive('נא להכניס מספר אתר תקין')
    .nullable()
    .optional(),
  lockerNumber: string().max(16, 'יש להזין עד 16 תווים בלבד'),
});
